import React from "react";
import ModalV2 from "../../../../../shared/components/modalV2";

interface SubmitTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
}

function SubmitTransferModal({
  isOpen,
  onClose,
  onClick,
}: SubmitTransferModalProps) {
  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[458px]"
      edges="rounded-xl"
    >
      <div className="w-full py-8 px-10 flex gap-y-2 flex-col">
        <div className="w-full flex flex-col items-center justify-center gap-y-6">
          <span className="text-[#101828] text-xl font-bold text-center leading-normal">
            Are you ready to submit <br />
            and transfer this file?
          </span>
          <div className="w-full flex items-center gap-3 pt-2">
            <button
              onClick={onClose}
              className="w-full bg-[#ECFDF3] rounded-lg p-3 text-[16px] font-medium text-[#027A48] hover:bg-[#D1FADF] transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onClick}
              className="w-full bg-[#00B074] rounded-lg p-3 text-[16px] font-medium text-white hover:bg-[#009060] transition-colors"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </ModalV2>
  );
}

export default SubmitTransferModal;

